import React from 'react'
import '@loyal_template/order.css'
import { Link } from 'react-router-dom'

const ProductOrderItemEmpty = () => {
  return (
    <div className='orders-item row py-3 col-12 px-3'>
      <div className='mr-auto ml-auto bg-ui-4 radius-circle px-3 py-3'>
        <i className='icon icon_package txt-headline color-brand-1' />
      </div>
      <div className='col-12 mr-auto ml-auto  clearfix' />
      <div className='col-10 col-md-4 mr-auto ml-auto mt-2'>
        <h3 className='txt-center txt-body'>
          <strong>Você ainda não fez nenhum pedido.</strong>
        </h3>
        <p className='txt-center txt-body-sm mt-1'>
          Aproveite nossas ofertas e comece a resgatar agora mesmo!</p>
      </div>
      <div className='col-12 clearfix' />
      <div className='col-8 col-md-4 mr-auto ml-auto  mt-2'>
        <Link
          to='/search'
          className='btn btn-sm btn-featured txt-center txt-uppercase'
          role='link'
        >
          Ver produtos
        </Link>
      </div>
    </div>
  )
}

export default ProductOrderItemEmpty



// WEBPACK FOOTER //
// ./src/Participant/MyOrders/ProductOrderList/Empty.js